var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1px",
    height: "1px",
    viewBox: "-7 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.781 7.875h3.094c0.563 0 1 0.438 1 1v0.719c0 0.469-0.344 0.906-0.781 1v14.844c0 0.969-0.813 1.75-1.813 1.75h-12.688c-1 0-1.781-0.781-1.781-1.75v-14.844c-0.438-0.094-0.813-0.531-0.813-1v-0.719c0-0.563 0.469-1 1.031-1h3.063v-1.313c0-0.969 0.781-1.781 1.781-1.781h6.125c1 0 1.781 0.813 1.781 1.781v1.313zM12 6.344h-6.125c-0.156 0-0.25 0.094-0.25 0.219v1.313h6.625v-1.313c0-0.125-0.094-0.219-0.25-0.219zM3.094 25.188h11.719c0.125 0 0.219-0.156 0.219-0.281v-14.281h-12.188v14.281c0 0.125 0.094 0.281 0.25 0.281zM5.5 24.031h-0.188c-0.563 0-1.031-0.469-1.031-1.031v-10.219c0-0.531 0.469-0.969 1.031-0.969h0.188c0.531 0 1 0.438 1 0.969v10.219c0 0.563-0.469 1.031-1 1.031zM9.031 24.031h-0.156c-0.563 0-1.031-0.469-1.031-1.031v-10.219c0-0.531 0.469-0.969 1.031-0.969h0.156c0.563 0 1.031 0.438 1.031 0.969v10.219c0 0.563-0.469 1.031-1.031 1.031zM12.563 24.031h-0.156c-0.563 0-1-0.469-1-1.031v-10.219c0-0.531 0.438-0.969 1-0.969h0.156c0.563 0 1.031 0.438 1.031 0.969v10.219c0 0.563-0.469 1.031-1.031 1.031z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.37059b35f38ef18b278c2b2a9c5f7621.svg";
export { ForwardRef as ReactComponent };